import ReactPixel from 'react-facebook-pixel'
import TagManager from 'react-gtm-module'

export const initializeFp = (email) => {
  if (import.meta.env.VITE_FACEBOOK_PIXEL_ID) {
    const advancedMatching = email ? { em: email } : {} // optional, more info: https://developers.facebook.com/docs/facebook-pixel/pixel-with-ads/conversion-tracking#advanced_match
    const options = {
      autoConfig: true, // set pixel's autoConfig
      debug: false, // enable logs
    }
    ReactPixel.init(import.meta.env.VITE_FACEBOOK_PIXEL_ID, advancedMatching, options)
  }
}

export const initializeTagManager = () => {
  if (import.meta.env.VITE_GOOGLE_TAG_ID) {
    const tagManagerArgs = {
      gtmId: import.meta.env.VITE_GOOGLE_TAG_ID,
    }

    TagManager.initialize(tagManagerArgs)
  }
}

export const trackingPage = (page) => {
  if (import.meta.env.PROD) {
    TagManager.dataLayer({
      dataLayer: {
        event: 'pageview',
        page,
      },
      dataLayerName: 'PageDataLayer',
    })
    ReactPixel.pageView(page)
  }
}

export const trackingEvent = (data = { reactPixel: {}, gtm: {} }) => {
  if (import.meta.env.PROD) {
    TagManager.dataLayer(data.gtm)
    ReactPixel.track(data.reactPixel?.eventName, data.reactPixel?.data)
  }
}
